import axiosInstance from "./global-instance";
import createScopedApi from "./createScopedApi";
import { tradeInApiUrl } from "../constants/url-constants";

const BASE_API_URL = `${tradeInApiUrl()}/api`;

export default createScopedApi(BASE_API_URL, axiosInstance);
